import {
  Button,
  Menu,
  MenuDivider,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Spinner,
  Tooltip,
} from "@fluentui/react-components";
import {
  ArrowDownloadRegular,
  Delete16Regular,
  Edit16Regular,
  MoreVertical20Regular,
  PlayRegular,
} from "@fluentui/react-icons";
import { ProjectStatus } from "apps/decooda/components/projects/projectConstants";
import { useSharedMenuStyles } from "theme/sharedStyles";
import { IAnalyticsCardMenuProps } from "./AnalyticsCardMenu.types";

export const AnalyticsCardMenu = ({
  onEdit,
  onDelete,
  onScore,
  onExport,
  isExporting,
  status,
  onOpenChange,
  isOwner,
}: IAnalyticsCardMenuProps): JSX.Element => {
  const sharedMenuStyles = useSharedMenuStyles();

  const isScoreDisabled = status === ProjectStatus.InProgress;
  const isExportDisabled = status !== ProjectStatus.Scored;

  const scoreLabel =
    status === ProjectStatus.NotScored
      ? "Score project"
      : status === ProjectStatus.Scored
        ? "Re-score project"
        : status === ProjectStatus.InProgress
          ? "Scoring in progress"
          : "Retry scoring";

  const exportLabel = isExporting
    ? "Exporting…"
    : status === ProjectStatus.Scored
      ? "Export project data"
      : "Score first to export";

  return (
    <Menu
      positioning={{ position: "below", align: "end" }}
      onOpenChange={(_e, data) => onOpenChange(data.open)}
    >
      <MenuTrigger>
        <Tooltip
          content="More options"
          relationship="label"
          showDelay={300}
          hideDelay={100}
        >
          <Button
            appearance="subtle"
            icon={<MoreVertical20Regular />}
            aria-label="More options"
          />
        </Tooltip>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          <MenuItem
            className={sharedMenuStyles.item}
            icon={<PlayRegular />}
            disabled={isScoreDisabled}
            onClick={(e) => {
              e.stopPropagation();
              onScore();
            }}
          >
            {scoreLabel}
          </MenuItem>
          <MenuItem
            className={sharedMenuStyles.item}
            icon={
              isExporting ? (
                <Spinner size="tiny" aria-hidden="true" />
              ) : (
                <ArrowDownloadRegular />
              )
            }
            disabled={isExportDisabled || isExporting}
            onClick={(e) => {
              e.stopPropagation();
              onExport();
            }}
          >
            {exportLabel}
          </MenuItem>
          {isOwner !== false && <MenuDivider />}
          {isOwner !== false && (
            <>
              <MenuItem
                className={sharedMenuStyles.item}
                icon={<Edit16Regular />}
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit();
                }}
              >
                Edit
              </MenuItem>
              <MenuItem
                className={sharedMenuStyles.itemDanger}
                icon={
                  <span className={sharedMenuStyles.itemIconDanger}>
                    <Delete16Regular />
                  </span>
                }
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete();
                }}
              >
                Delete
              </MenuItem>
            </>
          )}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
